import React, { forwardRef, memo, useState } from "react";
import { View } from "react-native";
import { TabProvider } from "./TabContext";

type TabsProps = {
  value?: string;
  children?: React.ReactNode;
  className?: string;
};

export const Tabs = memo(
  forwardRef<View, TabsProps>(({ value, children, ...props }, ref) => {
    const DEFAULT_TAB = "tab-0";
    const [currentActiveTab, setCurrentActiveTab] = useState<string>(
      value ?? DEFAULT_TAB,
    );

    const onChange = (newValue: string) => setCurrentActiveTab(newValue);

    return (
      <TabProvider currentActiveTab={currentActiveTab} onChange={onChange}>
        <View {...props} ref={ref}>
          {children}
        </View>
      </TabProvider>
    );
  }),
);
